import { createSvgIcon } from '@automata/mui-theme';
export const AgilentPlateLocIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.6616 29.5151C37.2641 29.107 38.0145 28.9817 38.717 29.1719L54.7381 33.5104C54.9931 33.5794 55.2355 33.6884 55.4563 33.8333L70.8716 43.9496C71.5758 44.4118 72 45.1974 72 46.0398V70.0857C72 70.7487 71.7366 71.3846 71.2678 71.8535L71.1501 71.9711C71.0016 72.1196 70.835 72.2488 70.6542 72.3557L49.2565 84.9997C48.4925 85.4512 47.5463 85.4638 46.7706 85.0328L29.7859 75.5969C28.9922 75.156 28.5 74.3194 28.5 73.4115V54.9999H31.5V73.1173L47.977 82.2712L69 69.8485V46.3097L53.877 36.3852L38.1541 32.1275L31.3412 36.7419C30.6553 37.2064 29.7226 37.027 29.258 36.3411C28.7935 35.6552 28.9729 34.7225 29.6588 34.2579L36.6616 29.5151Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.7994 36.418C28.9951 34.9701 30.6269 34.2138 31.8582 35.0005L48.0769 45.3625C48.6521 45.7299 49.0001 46.3653 49.0001 47.0478V60.9197C49.0001 61.6375 48.6155 62.3001 47.9924 62.6562L45.4997 64.0807C44.877 64.4365 44.1115 64.4316 43.4933 64.068L27.5661 54.6991C26.8718 54.2907 26.4903 53.5056 26.5982 52.7074L28.7994 36.418ZM47.0001 47.0478L30.7814 36.6859L28.5801 52.9752L44.5074 62.3442L47.0001 60.9197V47.0478Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.0001 32.3814C63.8213 30.7525 66.4019 26.3753 66.402 22.3815C66.4022 18.3876 63.8218 16.9904 61.0006 18.6193C58.1794 20.2483 55.5988 24.6254 55.5987 28.6192C55.5986 32.6131 58.1789 34.0103 61.0001 32.3814ZM61 35.3814C65.4182 32.8304 68.9999 26.3385 69.0001 20.8814C69.0002 15.4242 65.4188 13.0683 61.0007 15.6193C56.5826 18.1703 53.0008 24.6622 53.0007 30.1193C53.0005 35.5765 56.5819 37.9324 61 35.3814Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.9103 27.9176C61.473 27.5927 62.2226 26.5342 62.2226 25.3301C62.2226 24.1259 61.4731 23.933 60.9104 24.2579C60.3477 24.5828 59.5982 25.6413 59.5981 26.8454C59.5981 28.0496 60.3476 28.2425 60.9103 27.9176ZM60.9102 30.9176C63.0698 29.6707 64.8205 26.4974 64.8206 23.83C64.8207 21.1625 63.0701 20.0109 60.9105 21.2579C58.7509 22.5048 57.0002 25.678 57.0001 28.3455C57 31.013 58.7506 32.1645 60.9102 30.9176Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M64.4755 23.7805L68.5983 42.104C68.9349 43.6001 67.5318 44.9029 66.0647 44.4564L57.0989 41.7276C56.0956 41.4223 55.4986 40.3937 55.731 39.371L58.0248 29.2784L59.975 29.7217L57.6813 39.8143L66.6471 42.543L62.5243 24.2195L64.4755 23.7805Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.2991 9.03108L65.5171 16.8755L66.4832 15.1243L52.2087 7.24875C51.9391 7.09998 51.5445 6.96097 51.0858 7.03532C50.5003 7.13021 49.8126 7.41415 49.1234 7.78515C48.4159 8.166 47.6383 8.67606 46.8605 9.28325C45.3132 10.4912 43.6993 12.1355 42.6318 14.0038C39.488 19.5054 39.7431 24.2936 40.4293 26.4706C40.5377 26.8143 40.7378 27.0944 40.979 27.3062L39.1057 31.0527L40.8946 31.9471L42.7027 28.3308L56.007 35.8699L56.993 34.1299L42.3201 25.8152C41.8162 24.1475 41.5245 19.9727 44.3682 14.996C45.2705 13.4171 46.6819 11.96 48.0913 10.8597C48.7918 10.3128 49.4754 9.86701 50.0714 9.54621C50.6093 9.25664 51.0275 9.09525 51.2991 9.03108ZM51.2368 8.99696C51.2368 8.99693 51.2375 8.99722 51.2388 8.99792C51.2375 8.99733 51.2368 8.99699 51.2368 8.99696Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.9847 46.1737L44.9847 63.1737L43.0151 62.8262L46.0151 45.8262L47.9847 46.1737ZM46.9999 84V59.5H48.9999V84H46.9999Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.7321 63.0001L33.7323 70.9989L43.3248 76.5375L43.3245 68.5387L33.7321 63.0001ZM32.866 60.5C32.3877 60.2239 32 60.4477 32 61L32.0004 70.9988C32.0004 71.5511 32.3881 72.2227 32.8664 72.4989L44.1909 79.0375C44.6692 79.3137 45.0569 79.0899 45.0568 78.5376L45.0565 68.5387C45.0565 67.9864 44.6688 67.3149 44.1905 67.0387L32.866 60.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.2021 76.0077L24.4639 79.8977L34.8276 85.8808L41.5658 81.9907L31.2021 76.0077ZM32.0682 74.5078C31.5899 74.2317 30.8144 74.2317 30.3361 74.5078L21.8658 79.3978C21.3875 79.6739 21.3875 80.1216 21.8658 80.3977L33.9616 87.3807C34.4399 87.6568 35.2153 87.6568 35.6936 87.3807L44.164 82.4907C44.6423 82.2146 44.6423 81.7669 44.164 81.4908L32.0682 74.5078Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.5256 30.1492L54.1281 39.786C55.403 40.5735 55.3911 42.4316 54.1061 43.2026L48.0146 46.8575L46.9856 45.1425L53.0771 41.4876L37.4746 31.8508L38.5256 30.1492Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.0298 41.2575C53.1638 40.7217 53.7067 40.3959 54.2425 40.5298L70.2425 44.5299L69.7575 46.4701L53.7575 42.4701C53.2217 42.3362 52.8959 41.7933 53.0298 41.2575Z"
    />
  </svg>,
  'AgilentPlateLocIcon'
);
